import { render, staticRenderFns } from "./StakingViewProgramsHappyHour.vue?vue&type=template&id=db38cbe6&lang=pug"
import script from "./StakingViewProgramsHappyHour.vue?vue&type=script&lang=ts"
export * from "./StakingViewProgramsHappyHour.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports